import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

// 通过 npm run build --mode xxx 决定主页面
// 在 .env.xxx 中配置 VUE_APP_HOME_PAGE:
//   - 不配置或 nav：主页面 = 导航聚合页
//   - "aitools"：主页面 = AI 工具笔记
const HOME_PAGE = process.env.VUE_APP_HOME_PAGE || "nav";

const routes = [
  HOME_PAGE === "aitools"
    ? { path: "/", redirect: "/aitools" }
    : {
        path: "/",
        name: "Home",
        component: Home,
      },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("../views/Test.vue"),
  },
  {
    path: "/aitools",
    component: () =>
      import(
        /* webpackChunkName: "aitools" */ "../views/aitools/AiToolsLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "ai-home",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiHome.vue"
          ),
      },
      {
        path: "library",
        name: "ai-library",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiLibrary.vue"
          ),
      },
      {
        path: "tool/:id",
        name: "ai-tool-detail",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiToolDetail.vue"
          ),
      },
      {
        path: "notes",
        name: "ai-notes",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiNotes.vue"
          ),
      },
      {
        path: "note/new",
        name: "ai-note-new",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiNoteEditor.vue"
          ),
      },
      {
        path: "note/edit/:id",
        name: "ai-note-edit",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiNoteEditor.vue"
          ),
      },
      {
        path: "note/:id",
        name: "ai-note-detail",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiNoteDetail.vue"
          ),
      },
      {
        path: "compare",
        name: "ai-compare",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiCompare.vue"
          ),
      },
      {
        path: "favorites",
        name: "ai-favorites",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiFavorites.vue"
          ),
      },
      {
        path: "about",
        name: "ai-about",
        component: () =>
          import(
            /* webpackChunkName: "aitools" */ "../views/aitools/AiAbout.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
